<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>公告管理</el-breadcrumb-item>
      <el-breadcrumb-item>添加公告</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图 -->
    <el-card>
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="100px">
        <!-- <el-tabs v-model="activeIndex" :tab-position="'left'" :before-leave="beforeTabLeave" @tab-click="tabClicked">
          <el-tab-pane label="商品详情" name="0"> -->
        <el-form-item label="公告标题" prop="title">
          <el-input v-model="addForm.title" placeholder="请输入公告标题，30字以内..." maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="公告内容" prop="content">
          <el-upload
            class="avatar-uploader"
            action="https://hsapi.hsxsn.cn//common/uploads"
            :file-list="fileList"
            :on-success="contentuploadSuccess"
            :on-error="contentuploadError"
            :before-upload="contentbeforeUpload"
            list-type="picture"
            :show-file-list="false"
            name="images"
            :limit="100"
          >
          </el-upload>

          <quill-editor v-model="addForm.content" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)">
          </quill-editor>

          <!-- 添加商品的按钮 -->
          <el-button type="primary" v-if="addForm.id == 0" class="btnAdd" @click="add">添加公告</el-button>
          <el-button type="primary" v-if="addForm.id > 0" class="btnAdd" @click="editSave">保存修改</el-button>
        </el-form-item>
        <!-- </el-tab-pane>
        </el-tabs> -->
      </el-form>
    </el-card>
  </div>
</template>

<script>
// 工具栏配置
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction

  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['image'],
  ['clean'], // remove formatting button
]

import _ from 'lodash'

export default {
  data () {
    return {

      // 添加商品的表单数据对象
      addForm: {
        id: 0,
        title: '',
        // 商品的详情描述
        content: '',
      },

      addFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入详细内容', trigger: 'blur' }
        ],
      },

      // 上传图片的URL地址
      uploadURL: 'https://hsapi.hsxsn.cn//common/uploads',
      // 图片上传组件的headers请求头对象
      headerObj: {
        Authorization: window.sessionStorage.getItem('token')
      },
      previewPath: '',
      previewVisible: false,
      // 上传的图片
      fileList: [],

      editorOption: {
        placeholder: '请输入内容',
        theme: 'snow', // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector('.avatar-uploader input').click()
                } else {
                  this.quill.format('image', false)
                }
              },
            },
          },
        },
      },
    }
  },

  created () {
    console.log(this.$route.query.id);
    if (this.$route.query.id > 0) {//编辑
      this.addForm.id = this.$route.query.id;
      this.getDetail(this.$route.query.id);
    }
  },

  methods: {

    // 获取所有商品详情
    async getDetail (id) {
      const { data: res } = await this.$http.get('admin/notice/detail', {
        params: {
          id: id
        }
      })
      if (res.code !== 200) {
        return this.$message.error('获取数据失败！')
      }
      this.addForm = res.result
      console.log(this.addForm)
    },

    // 添加商品
    add () {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) {
          return this.$message.error('请填写必要的表单项！')
        }
        // lodash   cloneDeep(obj)
        const form = _.cloneDeep(this.addForm)
        // 发起请求添加商品
        // 商品的名称，必须是唯一的
        const { data: res } = await this.$http.post('admin/notice/add', form)
        if (res.code !== 200) {
          return this.$message.error('添加失败！')
        }
        this.$message.success('添加成功！')
        this.$router.push('/noticeList')
      })
    },

    //编辑保存
    async editSave () {
      // 发起请求添加商品
      // 商品的名称，必须是唯一的
      const form = _.cloneDeep(this.addForm)
      const { data: res } = await this.$http.post('admin/notice/edit', form)
      if (res.code !== 200) {
        return this.$message.error('修改失败！')
      }
      this.$message.success('修改成功！')
      this.$router.push('/noticeList')
    },


    // 富文本相关方法
    onEditorReady (editor) {
      // 准备编辑器
    },
    onEditorBlur () { }, // 失去焦点事件
    onEditorFocus () { }, // 获得焦点事件
    // 内容改变事件
    onEditorChange ({ editor, html, text }) {
      console.log(html);
      this.addForm.content = html;
    },

    // 富文本图片上传前
    contentbeforeUpload () {
      // 显示loading动画
    },

    contentuploadError () { },

    contentuploadSuccess (response, file) {
      console.log(response)
      // response为图片服务器返回的数据
      try {
        // 获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill
        // 如果上传成功
        if (response.code == '200') {
          // 获取光标所在位置
          let length = quill.getSelection().index
          // 插入图片  res.info为服务器返回的图片地址
          quill.insertEmbed(length, 'image', response.result.show)
          // 调整光标到最后
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
      } catch (e) {
        console.log(e)
        this.$message.error('图片插入失败')
      } finally {
        // loading动画消失
      }
    },

  },
  computed: {
    editor () {
      return this.$refs.myQuillEditor.quill
    },
  },
}
</script>

<style lang="less" scoped>
.lunboUpload {
  margin-top: 40px;
}
.el-checkbox {
  margin: 0 10px 0 0 !important;
}

.previewImg {
  width: 100%;
}

.btnAdd {
  margin-top: 15px;
}
</style>
